<template>
  <popup class="images-popup">
    <div v-if="showPopup('init')" class="new-wrap wrap-common rel init-state">
      <p class="tc title">Please select</p>
      <p class="new-btn">
        <vue-plupload
            class-name="input-btn upload-btn btn"
            text="Upload a Image"
            @init="handleUploaderInit"
            @added="handleAdded"
            @progress="handleProgress"
            @error="handleError"
            @uploaded="handleUploaded">
        </vue-plupload>
        <input class="input-btn select-btn btn tc" value="Select an Icon" type="button" @click="SelectIconsPopup"/>
      </p>
      <p class="close-btn btn-common" @click="handleClose">
        <i class="icon-close-line iconfont"></i>
      </p>
    </div>

    <div v-if="showPopup('exist')" class="images-wrap wrap-common rel exist-state">
      <div class="content clearfix">
        <p v-html="existImage" class="tc"></p>
        <p class="img-btn ">
          <input class="input-btn upload-btn tc btn" value="Change" type="button" @click="gotoInit"/>
          <input class="input-btn remove-btn tc btn"
                 value="Remove" type="button"
                 @click="handleImgRemove"/>
        </p>
      </div>
      <p class="close-btn btn-common" @click="handleClose">
        <i class="icon-close-line iconfont"></i>
      </p>
    </div>

    <div v-if="showPopup('icons')" class="icons-wrap wrap-common rel icons-state">
      <p class="title tc">Select an Icon</p>
     <form @submit.prevent="handleSearch(searchText)">
       <div class="search-wd">
         <p class="rel search-wrap">
           <input class="search" placeholder="Search icons" type="text"
                  :class="{'error-border': validation.hasError('searchText')}"
                  v-model="searchText">
           <button type="submit" class="pab search-btn"> <i class="iconfont icon-search-line "></i></button>
         </p>
         <p class="error">{{ validation.firstError('searchText') }}</p>
       </div>
     </form>
      <ul class="icont-list clearfix">
        <li @click="handleSelectIcon(item)" :key="item.key" v-for="item in filteredItems">
          <i class="ri-fw" :class="`ri-${item.key}-line`"></i>
          <p class="mark">{{ item.key }}</p>
        </li>

      </ul>
      <p class="close-btn btn-common" @click="handleClose">
        <i class="icon-close-line iconfont"></i>
      </p>
    </div>

  </popup>
</template>

<script>
import LS from 'local-storage';
import loading from "../../common/utils/loading";
import toast from "../../common/utils/toast";
import adminService from '../service/adminService';
import popup from "./popup.vue";
import VuePlupload from "./vue-plupload.vue";
import 'remixicon/fonts/remixicon.css';
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
  props: {
    block: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  components: {
    'vue-plupload': VuePlupload,
    popup,
  },
  data() {
    return {
      innerBlock: {},
      close: true,
      flag: true,
      popup: {
        icons: false,
      },
      uploadError: '',
      searchText: '',
      iconList: []
    }
  },
  computed: {
    exist() {
      if (this.innerBlock.icons && this.innerBlock.icons.length > 0) {
        return true;
      }

      if (this.innerBlock.image && this.innerBlock.image.length > 0) {
        return true;
      }

      return false;
    },
    uploadOpt() {
      return {
        url: adminService.getUploadURL(),
        filters: {
          multi_selection: false,
          max_file_size: '2mb',
          mime_types: [{
            title: "Image files",
            extensions: "jpeg,png,jpg,gif"
          }]
        },
      };
    },

    filteredItems() {
      if (this.searchText.length > 2) {
        const searchText = this.searchText;

        return this.iconList.filter((item) => {
          const key = item.key || '';
          if (`${key}`.includes(searchText)) {
            return true;
          }

          const first = item.keywords.find((item) => {
            return item.includes(searchText);
          });

          return !!first;
        })
      }
      return this.iconList;
    },

    existImage() {
      if (this.innerBlock.icons && this.innerBlock.icons.length > 0) {
        return this.innerBlock.icons;
      }

      if (this.innerBlock.image && this.innerBlock.image.length > 0) {
        return `<p class="imgupload"><img src="${this.innerBlock.image}"/></p>`;
      }

      return `<i class="iconfont icon-image-fill"></i>`
    }
  },

  methods: {

    showPopup(type) {
      switch (type) {
        case 'exist':
          return this.exist;
        case 'icons':
          return !this.exist && this.popup.icons;
        case 'init':
          return !this.exist && !this.popup.icons;
      }
    },

    handleClose() {
      loading.hide();
      toast.hide();
      this.$emit('close', this.close);
    },

    gotoInit() {
      this.innerBlock.image = '';
      this.innerBlock.icons = '';
    },

    SelectIconsPopup() {
      this.popup.icons = true
    },

    handleImgRemove() {
      this.innerBlock.image = '';
      this.innerBlock.icons = '';
      this.$emit('change', {...this.innerBlock});
      this.handleClose();
    },

    /**
     * 选 icons
     */
    handleSelectIcon(item) {
      this.innerBlock.icons = `<i class="ri-fw ri-${item.key}-line"></i>`;
      this.innerBlock.image = '';
      this.$emit('change', {...this.innerBlock});
      this.handleClose();
    },

    /**
     * uploader
     */
    handleUploaderInit(uploader) {
      uploader.setOption(this.uploadOpt);
    },

    handleAdded: function (uploader, files) {
      const token = LS.get('token');
      uploader.setOption({
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
      uploader.start();
    },

    handleProgress: function (uploader, file) {
      loading.show({
        content: `progress: ${file.percent}%`
      });
    },

    handleError: function (uploader, err) {
      const file = err.file || {};
      const filename = file.name || '';
      const msg = err.message;
      toast.show({
        content: msg,
        stayTime: 3000,
        withMask: false
      })
    },

    handleUploaded: function (uploader, file, result) {
      let json = {};
      try {
        json = JSON.parse(result.response);
      } catch (err) {
        console.error(err)
      }
      const status = json.status;
      const data = json.data || {};
      if (status) {
        this.innerBlock.icons = '';
        this.innerBlock.image = data.url;

        this.$emit('change', {...this.innerBlock});
        this.handleClose();
        return;
      }

      const error = json.error || {};
      const msg = error.msg;
      const validate = error.validate;
      if (validate) {
          toast.show({
            content: validate.file[0],
            stayTime: 3000,
            withMask: false
          })
        return;
      }
      if (msg) {
        toast.show({
          content: msg,
          stayTime: 3000,
          withMask: false
        })
      }
    },

    LoadingIcons() {
      loading.show();
      adminService.getIcons()
          .then((data) => {
            this.iconList = Object.entries(data).map(([key, value]) => {
              return {
                key,
                keywords: value,
              };
            });
          })
          .finally(() => {
            loading.hide();
          })
    },
    handleSearch: function(search){
      this.$validate()
    }


  },

  mounted() {
    this.innerBlock = {...this.block};
    this.LoadingIcons();
  },
  validators:{
    searchText: function (value) {

      return Validator.value(value).required().minLength(3);
    }
  }

}
</script>

